import { useState, useEffect } from "react";
import { Users, Trash2, Phone, Calendar } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { getClientes, deleteCliente } from "@/lib/api";

export default function AdminClientes() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const loadClientes = async () => {
    setLoading(true);
    try {
      const res = await getClientes();
      setClientes(res.data);
    } catch { toast.error("Error al cargar clientes"); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadClientes(); }, []);

  const handleDelete = async (id, nombre) => {
    if (!window.confirm(`¿Eliminar al cliente "${nombre}"?`)) return;
    try {
      await deleteCliente(id);
      toast.success("Cliente eliminado");
      loadClientes();
    } catch { toast.error("Error al eliminar"); }
  };

  const filtered = clientes.filter(c =>
    c.nombre?.toLowerCase().includes(search.toLowerCase()) ||
    c.telefono?.includes(search)
  );

  return (
    <div data-testid="admin-clientes">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-heading">Clientes</h1>
          <p className="text-muted-foreground">{clientes.length} clientes registrados</p>
        </div>
        <Input placeholder="Buscar por nombre o telefono..." value={search}
          onChange={e => setSearch(e.target.value)} className="max-w-xs h-10" data-testid="search-clientes" />
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><div className="spinner w-10 h-10" /></div>
      ) : filtered.length === 0 ? (
        <Card><CardContent className="p-12 text-center">
          <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-lg">{search ? "Sin resultados" : "No hay clientes"}</p>
        </CardContent></Card>
      ) : (
        <div className="grid gap-3">
          {filtered.map(c => (
            <Card key={c.id}>
              <CardContent className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
                    <span className="font-medium text-accent">{c.nombre?.charAt(0)?.toUpperCase()}</span>
                  </div>
                  <div>
                    <p className="font-medium">{c.nombre}</p>
                    <div className="flex items-center gap-3 text-sm text-muted-foreground">
                      <span className="flex items-center gap-1"><Phone className="h-3 w-3" />{c.telefono}</span>
                      <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{c.total_citas || 0} citas activas</span>
                    </div>
                  </div>
                </div>
                <Button variant="ghost" size="icon" className="text-destructive"
                  onClick={() => handleDelete(c.id, c.nombre)} data-testid={`btn-delete-${c.id}`}>
                  <Trash2 className="h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
